import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListStepsOnBoardingComponent } from './steps/list-steps-on-boarding.component';
import { ButtonModule } from 'primeng/button';
import { NameBotStepComponent } from './steps/name-bot-step.component';
import { ChipsModule } from 'primeng/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectDataSourceComponent } from './steps/select-data-source.component';
import { WebDataSourceComponent } from './steps/web-data-source.component';
import { UploadFileComponent } from './steps/upload-file.component';
import { ProcessChatbotComponent } from './steps/process-chatbot.component';
import { ReadyStepComponent } from './steps/ready-step.component';
import { RouterLink } from '@angular/router';
import { SelectPersonalityComponent } from './select-personallity/select-personallity.component';
import { CardDataSourceComponent } from './card-data-source/card-data-source.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RippleModule } from 'primeng/ripple';
import { NoInfoComponent } from './no-info/no-info.component';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonGlobotComponent } from '../../../shared/components/button-globot/button-globot.component';
import { AttentionScheduleConfigComponent } from '../../../shared/components/attention-schedule-config/attention-schedule-config.component';
import { ButtonGlobotStepsComponent } from '../../../shared/components/buttonsSteps/button-globot-steps.component';
import { EmbedHtmlComponent } from './embed-html/embed-html.component';
import { EmbedWordpressComponent } from './embed-wordpress/embed-wordpress.component';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { DiscordBotComponent } from './discord-bot/discord-bot.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessengerBotComponent } from './messenger-bot/messenger-bot.component';
import { SlackBotComponent } from './slack-bot/slack-bot.component';
import { InstagramBotComponent } from './instagram-bot/instagram-bot.component';
import { WhatsappBotComponent } from './whatsapp-bot/whatsapp-bot/whatsapp-bot.component';
import { KeyFilterModule } from 'primeng/keyfilter';
import { CardsRecordsComponent } from '../edit-bot/config/cards-records/cards-records.component';
import { ChannelSelectorComponent } from '../edit-bot/config/channel-selector/channel-selector.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { MaxTextPipe } from 'src/app/shared/pipes/max-text.pipe';
import { NotAvailableComponent } from './not-available/not-available.component';
import { BannerComponent } from './banner/banner.component';
import { DialogModule } from 'primeng/dialog';
import { ProfileComponent } from '../edit-user/profile/profile.component';
import { SubscriptionPlanComponent } from '../edit-user/subscription-plan/subscription-plan.component';
import { UserBillingComponent } from '../edit-user/user-billing/user-billing.component';
import { UserPaymentsComponent } from '../edit-user/user-payments/user-payments.component';
import { DeleteAccountComponent } from '../edit-user/delete-account/delete-account.component';
import { EmailPasswordComponent } from '../../../shared/components/email-password/email-password.component';
import { ReadyAccountComponent } from '../../../shared/components/ready-account/ready-account.component';
import { LottieComponent } from 'ngx-lottie';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProfilePictureComponent } from '../../../shared/components/profile-picture/profile-picture.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { AccordionModule } from 'primeng/accordion';
import { StatisticsComponent } from '../dashboard/statistics/statistics.component';
import { LeadsComponent } from '../dashboard/leads/leads.component';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { NgChartsModule } from 'ng2-charts';
import { TableModule } from 'primeng/table';
import { CustomDatePipe } from 'src/app/shared/pipes/custom-date.pipe';
import { TypeSubscriptionPlansComponent } from './type-subscription-plans/type-subscription-plans.component';
import { ExpiredPlanComponent } from './expired-plan/expired-plan.component';
import { PayNotificationComponent } from './pay-notification/pay-notification.component';
import { ConversationCardsComponent } from '../globot-live/conversation-cards/conversation-cards.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SearchFilterPipe } from 'src/app/shared/pipes/search-filter.pipe';
import { InformationSectionComponent } from '../globot-live/information-section/information-section.component';
import { CustomerFormComponent } from '../globot-live/customer-form/customer-form.component';
import { SpinnerCheckComponent } from 'src/app/shared/components/spinner-check/spinner-check.component';
import { ChatMessagesListComponent } from '../../../shared/components/chat-messages-list/chat-messages-list.component';
import { PreferencesBoxComponent } from '../globot-live/preferences-box/preferences-box.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge';
import { InputTextModule } from 'primeng/inputtext';
import { SubscriptionSuccessModalComponent } from './subscription-success-modal/subscription-success-modal.component';
import { InstagramPhonePreviewComponent } from '../../../shared/components/instagram-phone-preview/instagram-phone-preview.component';
import { AcquisitionSourceModalComponent } from './acquisition-source-modal/acquisition-source-modal.component';

@NgModule({
  declarations: [
    ListStepsOnBoardingComponent,
    NameBotStepComponent,
    SelectDataSourceComponent,
    WebDataSourceComponent,
    UploadFileComponent,
    ProcessChatbotComponent,
    ReadyStepComponent,
    SelectPersonalityComponent,
    CardDataSourceComponent,
    NoInfoComponent,
    EmbedHtmlComponent,
    EmbedWordpressComponent,
    DiscordBotComponent,
    MessengerBotComponent,
    SlackBotComponent,
    InstagramBotComponent,
    WhatsappBotComponent,
    CardsRecordsComponent,
    ChannelSelectorComponent,
    MaxTextPipe,
    NotAvailableComponent,
    BannerComponent,
    ProfileComponent,
    SubscriptionPlanComponent,
    UserBillingComponent,
    UserPaymentsComponent,
    DeleteAccountComponent,
    EmailPasswordComponent,
    ReadyAccountComponent,
    ProfilePictureComponent,
    StatisticsComponent,
    LeadsComponent,
    CustomDatePipe,
    TypeSubscriptionPlansComponent,
    ExpiredPlanComponent,
    PayNotificationComponent,
    ConversationCardsComponent,
    SearchFilterPipe,
    InformationSectionComponent,
    CustomerFormComponent,
    SpinnerCheckComponent,
    ChatMessagesListComponent,
    PreferencesBoxComponent,
    SubscriptionSuccessModalComponent,
    AcquisitionSourceModalComponent,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    ChipsModule,
    FormsModule,
    RouterLink,
    DialogModule,
    ConfirmDialogModule,
    RippleModule,
    ReactiveFormsModule,
    TooltipModule,
    ButtonGlobotComponent,
    ButtonGlobotStepsComponent,
    AttentionScheduleConfigComponent,
    MessagesModule,
    MessageModule,
    InputSwitchModule,
    KeyFilterModule,
    MultiSelectModule,
    LottieComponent,
    ImageCropperModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    AccordionModule,
    CalendarModule,
    ChartModule,
    NgChartsModule,
    TableModule,
    AutoCompleteModule,
    RadioButtonModule,
    DropdownModule,
    CheckboxModule,
    InputTextareaModule,
    TagModule,
    BadgeModule,
    InputTextModule,
    InstagramPhonePreviewComponent,
  ],
  exports: [
    ListStepsOnBoardingComponent,
    NameBotStepComponent,
    SelectDataSourceComponent,
    WebDataSourceComponent,
    UploadFileComponent,
    ProcessChatbotComponent,
    ReadyStepComponent,
    SelectPersonalityComponent,
    CardDataSourceComponent,
    NoInfoComponent,
    EmbedHtmlComponent,
    EmbedWordpressComponent,
    DiscordBotComponent,
    MessengerBotComponent,
    SlackBotComponent,
    InstagramBotComponent,
    WhatsappBotComponent,
    CardsRecordsComponent,
    ChannelSelectorComponent,
    NotAvailableComponent,
    BannerComponent,
    ProfileComponent,
    SubscriptionPlanComponent,
    UserBillingComponent,
    UserPaymentsComponent,
    DeleteAccountComponent,
    EmailPasswordComponent,
    ReadyAccountComponent,
    ProfilePictureComponent,
    StatisticsComponent,
    LeadsComponent,
    TypeSubscriptionPlansComponent,
    ExpiredPlanComponent,
    PayNotificationComponent,
    ConversationCardsComponent,
    SearchFilterPipe,
    InformationSectionComponent,
    CustomerFormComponent,
    SpinnerCheckComponent,
    ChatMessagesListComponent,
    PreferencesBoxComponent,
    SubscriptionSuccessModalComponent,
    AcquisitionSourceModalComponent,
  ],
})
export class ComponentsDashboardModule {}
